/**
 * DeveloperFooter - Shared footer component for developer registration pages
 *
 * Displays:
 * - Loren Data logo
 * - Copyright information with links to Terms of Service and Privacy Policy
 * - Version information (ECGridOS and Portal)
 * - View Change Log link
 *
 * Only visible on desktop (lg breakpoint and above)
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from '@/i18n/namespaces';

export const DeveloperFooter: React.FC = () => {
  const { t } = useTranslation(NS.COMMON);

  return (
    <div className="hidden lg:flex items-center justify-center gap-3 px-4 sm:px-6 lg:px-10 py-6 border-t border-gray-200">
      <img
        src="/img/lorenData_Logo1x.png"
        alt="Loren Data - Powered by Innovation"
        className="h-6 w-auto flex-shrink-0"
      />
      <div className="text-[10px] text-gray-600 leading-relaxed text-center">
        <p>
          {t('Footer_Copyright', '© 2015-2026 Loren Data Corp. All Rights Reserved.')}{' '}
          <a href="/terms" className="underline hover:text-gray-900 transition-colors">
            {t('Footer_TermsOfService', 'Terms of Service')}
          </a>{' '}
          &amp;{' '}
          <a
            href="https://www.ld.com/privacy/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-900 transition-colors"
          >
            {t('Footer_PrivacyPolicy', 'Privacy Policy')}
          </a>
        </p>
        <p>
          {t(
            'Footer_PoweredBy',
            'Powered by ECGridOS v4.1 (Build 485), Portal Version: 1.6 Build: 6.8 -'
          )}{' '}
          <a href="/change-log" className="underline hover:text-gray-900 transition-colors">
            {t('Footer_ViewChangeLog', 'View Change Log')}
          </a>
        </p>
      </div>
    </div>
  );
};
